import isUndefined from 'lodash.isundefined';
import isNull from 'lodash.isnull';
import isEmpty from 'lodash.isempty';

const isUndefinedOrNullOrEmpty = (value) => isUndefined(value)
|| isNull(value)
|| isEmpty(value);

export default isUndefinedOrNullOrEmpty;
